(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chd-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chd-navigation')) {
  customElements.define('chd-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.header = this.closest('.chd-header');
      this.drawer = this.querySelector('dialog');
      this.launch = this.header.querySelector('[data-chd-nav-launch]');
      this.desktop = this.querySelector('.chd-nav__desktop');
      this.items = [...this.querySelectorAll('[data-nav-item]')];
      this.media = matchMedia('(min-width: 1000px)');
      this.scroll = this.querySelector('.chd-nav__drawer-scroll');
      this.classList.add('is-enhanced');
      this.items.forEach(item => {
        const button = [...item.querySelectorAll('[data-nav-group]')].find(group => group.firstElementChild.textContent.trim().toLowerCase() === (item.dataset.initialGroup || '').trim().toLowerCase()) || item.querySelector('[data-nav-group]');
        if (button) this.selectGroup(button);
        item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
        item.addEventListener('toggle', () => {
          item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
          if (item.open) {
            this.items.forEach(other => { if (other !== item) other.open = false; });
            this.position();
          }
          this.querySelector('[data-nav-scrim]').hidden = !this.items.some(other => other.open);
        }, {signal});
        item.addEventListener('pointerenter', event => {
          clearTimeout(this.leaveTimer);
          if (event.pointerType !== 'mouse' || !this.media.matches || this.dataset.openTrigger !== 'hover') return;
          this.keyboardMode = false;
          this.openTimer = setTimeout(() => { item.open = true; }, 150);
        }, {signal});
        item.addEventListener('pointerleave', () => {
          clearTimeout(this.openTimer);
          this.leaveTimer = setTimeout(() => {
            if (!this.keyboardMode || !item.contains(document.activeElement)) item.open = false;
          }, 260);
        }, {signal});
      });
      this.launch?.addEventListener('click', () => this.openDrawer(), {signal});
      this.addEventListener('click', event => {
        const group = event.target.closest('[data-nav-group]');
        if (group) this.selectGroup(group);
        const forward = event.target.closest('[data-nav-forward]');
        if (forward) this.forward(forward);
        if (event.target.closest('[data-nav-back]')) this.back();
        if (event.target.closest('[data-nav-close], [data-nav-scrim]')) this.close();
        if (event.target.closest('a')) this.close(false);
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Tab' && this.drawer.open) {
          const controls = [...this.drawer.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex]')].filter(element => {
            const closedGroup = element.closest('details:not([open])');
            return element.tabIndex >= 0 && !element.disabled && !element.closest('[hidden]') &&
              (!closedGroup || element === closedGroup.querySelector('summary')) &&
              element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
          });
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first?.focus();
          }
        }
        const group = event.target.closest('[data-nav-group]');
        if (group && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
          const buttons = [...group.parentElement.querySelectorAll('button')];
          const index = buttons.indexOf(group);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
          event.preventDefault(); this.selectGroup(buttons[next]); buttons[next].focus();
        }
      }, {signal});
      this.drawer.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, {signal});
      this.drawer.addEventListener('close', () => this.releaseDrawer(), {signal});
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, {signal});
      document.addEventListener('pointerdown', event => {
        this.keyboardMode = false;
        if (!this.contains(event.target) && event.target !== this.launch && !this.launch?.contains(event.target)) this.closeDesktop();
      }, {signal});
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeDesktop();
      }, {signal});
      document.addEventListener('keydown', event => {
        this.keyboardMode = true;
        if (event.key === 'Escape' && !this.drawer.open) {
          const open = this.items.find(item => item.open);
          if (open) { event.preventDefault(); this.closeDesktop(); open.querySelector('summary').focus(); }
        }
      }, {signal});
      document.addEventListener('chd:cart:opened', () => this.close(false), {signal});
      this.media.addEventListener('change', () => this.close(false), {signal});
      window.addEventListener('scroll', () => this.position(), {passive:true,signal});
      this.resizeObserver = new ResizeObserver(() => {
        this.position();
        document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
      });
      this.resizeObserver.observe(this.header);
      document.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-nav-item]');
        if (item && this.contains(item) && this.media.matches) item.open = true;
      }, {signal});
      document.addEventListener('shopify:section:deselect', () => this.close(false), {signal});
      this.position();
    }
    position() {
      this.style.setProperty('--chd-nav-bottom', Math.max(0, this.desktop.getBoundingClientRect().bottom) + 'px');
    }
    selectGroup(button) {
      const panel = button.closest('.chd-nav__panel');
      panel.querySelectorAll('[data-nav-group]').forEach(other => other.setAttribute('aria-expanded', String(other === button)));
      panel.querySelectorAll('[data-nav-content]').forEach(content => { content.hidden = content.id !== button.dataset.navGroup; });
    }
    closeDesktop() {
      clearTimeout(this.openTimer); clearTimeout(this.leaveTimer);
      this.items.forEach(item => { item.open = false; item.querySelector('summary').setAttribute('aria-expanded','false'); });
      this.querySelector('[data-nav-scrim]').hidden = true;
    }
    openDrawer() {
      if (this.media.matches || this.drawer.open) return;
      this.closeDesktop();
      const cartToggle = this.header.querySelector('.header__cart-toggle[aria-expanded="true"]');
      if (cartToggle) cartToggle.click();
      this.back(false);
      this.drawer.showModal();
      document.documentElement.classList.add('chd-nav-locked');
      this.launch?.setAttribute('aria-expanded','true');
      this.querySelector('[data-nav-close]').focus({preventScroll:true});
    }
    forward(button) {
      this.lastForward = button;
      this.rootScroll = this.scroll.scrollTop;
      this.querySelector('[data-nav-root]').hidden = true;
      const panel = this.querySelector('#' + CSS.escape(button.dataset.navForward));
      panel.hidden = false;
      button.setAttribute('aria-expanded','true');
      this.querySelector('[data-nav-title]').textContent = panel.dataset.title;
      this.querySelector('[data-nav-back]').hidden = false;
      this.scroll.scrollTop = 0;
      this.querySelector('[data-nav-back]').focus({preventScroll:true});
    }
    back(restore = true) {
      this.querySelector('[data-nav-root]').hidden = false;
      this.querySelectorAll('[data-nav-mobile-panel]').forEach(panel => { panel.hidden = true; });
      this.querySelectorAll('[data-nav-forward]').forEach(button => button.setAttribute('aria-expanded','false'));
      this.querySelector('[data-nav-back]').hidden = true;
      const title = this.querySelector('[data-nav-title]');
      title.textContent = title.dataset.rootTitle;
      this.scroll.scrollTop = restore ? this.rootScroll || 0 : 0;
      if (restore) this.lastForward?.focus({preventScroll:true});
    }
    releaseDrawer() {
      if (this.drawer.open) return;
      document.documentElement.classList.remove('chd-nav-locked');
      this.launch?.setAttribute('aria-expanded','false');
    }
    close(restore = true) {
      this.closeDesktop();
      if (this.drawer.open) {
        this.drawer.close();
        this.releaseDrawer();
        if (restore && !this.media.matches) this.launch?.focus({preventScroll:true});
      }
    }
    disconnectedCallback() {
      this.close(false);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
